import React, { ReactElement } from "react";
import { gql, useMutation } from "@apollo/client";
import { normalizeErrors } from "../../../../utils/normalizeErrors";
import { NormalizedErrorMap } from "../../../../types/NormalizedErrorMap";
import { GetBankListMutationMutation } from "../../../../schemaTypes";

export const getBankListMutation = gql`
  mutation GetBankListMutation {
    getBankList {
      errors {
        path
        message
      }
      message
      data {
        id
        code
        name
        provider_type
      }
    }
  }
`;

interface BankListData {
  id?: number | null;
  code?: string | null;
  name?: string | null;
  provider_type?: string | null;
}

interface Props {
  children: (
    data: {
      submitGetBankList: () => Promise<NormalizedErrorMap | null>;
      loading: boolean;
      error: any;
      message: string | null;
      bankListData: BankListData[] | null;
    }
  ) => ReactElement | null;
}

export const GetBankListController: React.FC<Props> = ({ children }) => {
  const [mutate, { loading, error, data }] = useMutation<GetBankListMutationMutation>(
    getBankListMutation
  );

  const submitGetBankList = async () => {
    const { data: { getBankList } = {} }: any = await mutate();

    if (getBankList?.errors) {
      return normalizeErrors(getBankList.errors);
    }

    return null;
  };

  const message = data?.getBankList?.message || null;

  const rawBankList = data?.getBankList?.data || null;

  const bankListData: BankListData[] | null = rawBankList
    ? rawBankList.filter((b: any): b is BankListData => b !== null)
    : null;

  return children({
    submitGetBankList,
    loading,
    error,
    message,
    bankListData,
  });
};
